import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from '../../config/reduxIndex';
import PMBP from '../../components/projectmanager/new/BP/PMBP';
import { makeRandomString } from '../../utilities/Utility';
import moment from 'moment-timezone';

class PMBPContainer extends Component {

	state = {
		currentItem: null,
		tempContact: null,
		currentContact: 0,
		currentContactItem: null,
		saved: true,
		filteredProjects: null,
		assignedContacts: [],
		newCommentLine: {
			uniqueID: '',
			author: '',
			createdBy: '',
			date: '',
			time: '',
			comment: ''
		},
	}

	componentWillMount() {
		this.retrieveAndFilter();
		this.retrieveComments();
		this.retrieveContacts();
	}

	componentDidUpdate(prevProps) {
		if (prevProps !== this.props) {
			this.retrieveAndFilter();
		}
	}

	retrieveAndFilter = () => {
		const p = this.props;
		let cur = p.reduxData.currentBP;
		let filt = p.reduxData.storedProjects.filter(pj => pj.parentID === cur.uniqueID);

		this.setState({
			currentItem: cur,
			currentContactItem: p.reduxData.storedContacts[this.state.currentContact],
			assignedContacts: p.reduxData.storedContacts,
			filteredProjects: filt
		})
	}

	retrieveComments = () => {
		const p = this.props;
		let cur = p.reduxData.currentBP;
		p.getComments(cur.uniqueID);
	}

	retrieveContacts = () => {
		const p = this.props;
		let cur = p.reduxData.currentBP;
		p.getContactsForBP(cur.uniqueID);
	}

	componentFunctions = () => {
		var funcs = [];
		let obj = this;

		Object.getOwnPropertyNames(obj).forEach(function (property) {
			if (typeof obj[property] === 'function') {
				funcs[property] = obj[property];
			}
		});

		return funcs;
	}

	render() {
		return (
			<PMBP
				{...this.props}
				state={this.state}
				{...this.componentFunctions()}
			/>
		);
	}

	goBack = () => {
		const { setRoute, changeMode } = this.props;
		changeMode("home", null);
		//setRoute('/projectmanager/');
	}

	toggleSaved = () => {
		this.props.updateBP(this.state.currentItem);
		this.setState({
			saved: true
		})
	}

	onChange = (value, attr) => {
		let newBP = Object.assign({}, this.state.currentItem);
		newBP[attr] = value;
		this.setState({
			currentItem: newBP,
			saved: false
		})
	}

	addProject = () => {
		let newProj = {
			uniqueID: makeRandomString(20),
			parentID: this.state.currentItem.uniqueID,
			display: "... ",
			bp: this.state.currentItem.companyName,
			description: '...',
			phase: '0',
			phases: [],
			assigned: [],
			attachments: [],
			status: 'planned',
		}

		this.props.setAttributeByObj({
			overlayEditType: 'project',
			temp: newProj
		});

		this.props.openOverlay('pmEdit');
	}

	saveBPContact = () => {
		let newContact = {
			role: " ... ",
			name: '',
			firstName: " ... ",
			lastName: " ... ",
			email: "...",
			phone1: "###-###-####",
			notes: " ..."
		}

		this.setState(function () {
			return {
				tempContact: newContact,
			}
		});

		this.props.setAttributeByObj({
			overlayEditType: 'contacts',
			temp: newContact
		});

		this.props.openOverlay('pmEdit');
	}

	editContact = (id) => {
		const p = this.props;
		let loc = p.reduxData.storedContacts.findIndex(indexOfProject)

		let newContact = Object.assign({}, p.reduxData.storedContacts[loc]);
		p.setAttributeByObj({
			overlayEditType: 'contacts-edit',
			temp: newContact
		});

		p.openOverlay('pmEdit');

		function indexOfProject(ct) {
			return ct.uniqueID === id;
		}
	}

	editContactField = (value, field) => {
		let newTemp = Object.assign({}, this.state.tempContact);
		newTemp[field.attr] = value;
		this.setState(function () {
			return {
				tempContact: newTemp,
			}
		});
	}

	editContactNotes = (e) => {
		const attr = e.target.getAttribute('attr');
		let newTemp = Object.assign({}, this.state.tempContact);
		newTemp[attr] = e.target.value;
		this.setState(function () {
			return {
				tempContact: newTemp,
			}
		});
	}

	addAdditionalDetail = () => {

		const p = this.props;
		const { currentUser } = p.reduxData;

		let temp = Object.assign({}, this.state.newCommentLine);
		temp.parentID = this.state.currentItem.uniqueID;
		temp.uniqueID = makeRandomString(24);
		temp.createdBy = currentUser;
		//temp.author = getUserName(currentUser);
		temp.date = moment(new Date()).format('MM/DD/YYYY');
		temp.time = new moment().format("HH:mm A");

		p.saveComment(temp);

		this.setState({
			newCommentLine: {
				uniqueID: '',
				author: '',
				createdBy: '',
				date: '',
				time: '',
				comment: ''
			}
		})

	}

	onChangeAdditionalDetail = (value, returnObj) => {
		let newComment = Object.assign({}, this.state.newCommentLine);
		newComment[returnObj.attr] = value;
		this.setState({
			newCommentLine: newComment,
		})
	}


}

function mapStateToProps(state) {
	return {
		reduxData: state.pmData
	}
}

const mapDispatchToProps = dispatch => {
	return {
		setRoute: (route) => {
			dispatch(actions.routing.setRoute(route));
		},
		setAttributeByObj: (obj) => {
			dispatch(actions.pm.setAttributeByObj(obj));
		},
		openOverlay: (obj) => {
			dispatch(actions.globalState.openOverlay(obj));
		},
		updateBP: (obj) => {
			dispatch(actions.pm.updateBP(obj))
		},
		saveBPContact: (obj) => {
			dispatch(actions.pm.saveBPContact(obj))
		},
		getComments: (obj) => {
			dispatch(actions.pm.getComments(obj))
		},
		saveComment: (obj) => {
			dispatch(actions.pm.saveComment(obj))
		},
		updateComment: (obj) => {
			dispatch(actions.pm.updateComment(obj))
		},
		getContactsForBP: (id) => {
			dispatch(actions.pm.getContactsForBP(id));
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(PMBPContainer);


// WEBPACK FOOTER //
// ./src/containers/projectmanager/PMBPContainer.js